import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import api from './utils/api.js';
import Util from "./utils/util";
import axios from 'axios';
import "element-ui/lib/theme-chalk/index.css";

Vue.config.productionTip = false;
Vue.prototype.api = api;
Vue.prototype.$util = Util;
Vue.prototype.$axios = axios;

Vue.use(ElementUI);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");

// 使用rem以及屏幕分辨率自适应  分为四档：3840/2560/1920/1366 以1080P分辨率为基础
const setFontSize = () => {
  const htmlDom = document.getElementsByTagName("html")[0];
  let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
  htmlDom.style.fontSize = `${htmlWidth / 192}px`;
};

import "./font-style/font.css"
window.onresize = setFontSize;
setFontSize();
